<template>
  <div id="app" class="container">
    <Search @submit-search="submitSearch"/>
    <main>
      <div class="result-content">
        <Tabnav v-if="articleNo && serialNo" @tab-change="t => this.currentTabComponent = t" :articleNo="articleNo" :serialNo="serialNo" />
        <alert-message v-if="errorMessageKey" :errorMessageKey="errorMessageKey"
                        :errorClass="errorClass" />
        <transition name="fade" mode="out-in">
          <keep-alive>
            <component
              v-bind:is="currentTabComponent"
              :articleNo="articleNo" :serialNo="serialNo" class="main-content" @error:api="handleError"
              @success:api="handleSuccess" v-if="articleNo && serialNo">
            </component>
          </keep-alive>
        </transition>
      </div>
      <sidenav class="sidenav" :error="error" :info-response="infoResponse" />
    </main>
  </div>
</template>

<script>
  import Search from '@/components/search'
  import Tabnav from '@/components/tabnav'
  import Sidenav from '@/components/sidenav'
  import AlertMessage from '@/components/alert-message'

  export default {
    name: 'App',
    components: {
      AlertMessage,
      Sidenav,
      Search,
      Tabnav
    },
    data () {
      return {
        articleNo: null,
        serialNo: null,
        error: null,
        infoResponse: null,
        errorClass: 'danger',
        currentTabComponent: 'rl-il'
      }
    },
    computed: {
      errorMessageKey: function () {
        let errorMessageKey = null
        if (this.error) {
          errorMessageKey = this.error.errorKey
          if (this.error.status === 404) {
            errorMessageKey = 'hs.att-dashboard.item.404'
          }
        }
        return errorMessageKey
      }
    },
    methods: {
      submitSearch: function (emitValue) {
        this.articleNo = emitValue.articleNo
        this.serialNo = emitValue.serialNo
      },
      handleError (e) {
        this.error = e
        this.infoResponse = null
      },
      handleSuccess (response, name) {
        this.infoResponse = response
        this.error = null
      }
    }
  }
</script>

<style lang="scss">
  main {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  }

  .main-content,
  .sidenav {
    width: 100%;
  }

  .result-content {
    position: relative;
    width: 100%;
  }

  @media only screen and (min-width: $screen-sm-min) {
    .sidenav {
      width: (100%/3);
      padding-left: 1rem;
    }

    .result-content {
      width: (100%/3*2);
      padding-right: 1rem;
    }
  }

  @media only screen and (min-width: $screen-md-min) {
    .sidenav {
      width: 25%;
    }

    .result-content {
      width: 75%;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

</style>
